
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return require("private-next-pages/[slug].tsx");
      }
    ]);
  